import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Map/SearchInput/index.js",
    _this = this;

import React, { useCallback, useMemo, useState } from 'react';
import styled from 'styled-components';
import SearchIcon from '@dls/assets/icons/Search';
import { useTheme } from '../../../core/ThemeProvider';
import InputText from '../../InputText';
var StyledSearchIconContainer = styled.div.withConfig({
  displayName: "SearchInput__StyledSearchIconContainer",
  componentId: "sc-1p3zjio-0"
})(["display:flex;cursor:pointer;"]);
var enterKeyCode = 13;

var SearchInput = function SearchInput(_ref) {
  var label = _ref.label,
      errorMessage = _ref.errorMessage,
      onSearch = _ref.onSearch,
      _ref$preSearchTerm = _ref.preSearchTerm,
      preSearchTerm = _ref$preSearchTerm === void 0 ? '' : _ref$preSearchTerm;

  var _useState = useState(preSearchTerm),
      _useState2 = _slicedToArray(_useState, 2),
      searchTerm = _useState2[0],
      setSearchItem = _useState2[1];

  var _useTheme = useTheme(),
      theme = _useTheme.theme;
  /**
   * Notify the parent component with search term, when user hits the 'enter' key
   */


  var onSearchInputKeyPress = useCallback(function (event) {
    if (event.charCode === enterKeyCode) {
      event.preventDefault();
      onSearch && onSearch(searchTerm);
    }
  }, [onSearch, searchTerm]);
  var onSearchIconClick = useCallback(function () {
    onSearch && onSearch(searchTerm);
  }, [onSearch, searchTerm]);
  var searchIcon = useMemo(function () {
    return /*#__PURE__*/React.createElement(StyledSearchIconContainer, {
      onClick: onSearchIconClick,
      "data-testid": "search-icon",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 38,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(SearchIcon, {
      color: theme.cl_sec_d1,
      size: 22,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 42,
        columnNumber: 9
      }
    }));
  }, [onSearchIconClick]);
  var onSearchInputChange = useCallback(function (e) {
    setSearchItem(e.target.value);
  }, []);
  return /*#__PURE__*/React.createElement(InputText, {
    type: 'number',
    value: searchTerm,
    label: label,
    bgColor: "haze",
    suffix: searchIcon,
    onChange: onSearchInputChange,
    error: !!errorMessage,
    hintMessage: errorMessage,
    onKeyPress: onSearchInputKeyPress,
    "data-testid": "search-input",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52,
      columnNumber: 5
    }
  });
};

export default SearchInput;